import { render, staticRenderFns } from "./FeatureRequest.vue?vue&type=template&id=47598ac0&"
import script from "./FeatureRequest.vue?vue&type=script&lang=js&"
export * from "./FeatureRequest.vue?vue&type=script&lang=js&"
import style0 from "./FeatureRequest.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports